import {DBReader, DeviceDataLimit, WildlifeEventUpload} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public DBReader: DBReader,
    public DeviceDataLimit: DeviceDataLimit,
    public WildlifeEventUpload: WildlifeEventUpload,
  ) {}
}